// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue2392(props) {
    return (
        <svg
            id="_x32_392"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
            style={{
                enableBackground: 'new 0 0 250 250',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0022;}\n\t.st11{display:none;}\n\t.st12{display:inline;}\n\t.st13{font-size:4.995px;}\n\t.st14{fill:none;stroke:#B3B3B3;stroke-miterlimit:3.92;}\n\t.st15{fill:none;stroke:#B7B7B7;}\n"
                }
            </style>
            <g id="HOU">
                <g id="compass">
                    <path
                        className="st0"
                        d="M229.6,208.1l-4.2-8.2l-0.8-7.9l3.9,6.9L229.6,208.1z"
                    />
                    <path
                        className="st1"
                        d="M231.7,214.3c-8.1,2.6-16.9-1.9-19.5-10s1.9-16.9,10-19.5s16.9,1.9,19.5,10 C244.4,202.9,239.9,211.7,231.7,214.3z M222.7,186c-7.5,2.4-11.6,10.4-9.2,17.8c2.4,7.5,10.4,11.6,17.8,9.2 c7.5-2.4,11.6-10.4,9.2-17.8C238.1,187.7,230.1,183.6,222.7,186z"
                    />
                    <path
                        className="st0"
                        d="M228.4,196.9c1.5,0.8,2,2.5,1.3,4c-0.8,1.5-2.5,2-4,1.3c-1.5-0.8-2-2.5-1.3-4S226.9,196.1,228.4,196.9z  M223,191.1l-0.9-2.9l0.4-0.1l2,1.6l-0.6-2l0.5-0.2l0.9,2.9l-0.4,0.1l-2-1.6l0.6,2L223,191.1z"
                    />
                    <path
                        className="st2"
                        d="M227.8,198.1c0.8,0.4,1.1,1.4,0.7,2.2c-0.4,0.8-1.4,1.1-2.2,0.7c-0.8-0.4-1.1-1.4-0.7-2.2 C226,198,227,197.6,227.8,198.1z"
                    />
                </g>
                <g id="distances">
                    <text
                        id="right"
                        transform="matrix(1 0 0 1 224.7256 111.0234)"
                        className="st3 st4 st5"
                    >
                        326
                    </text>
                    <text
                        id="right-center_1_"
                        transform="matrix(1 0 0 1 173.7773 54.1211)"
                        className="st3 st4 st5"
                    >
                        373
                    </text>
                    <text
                        id="center"
                        transform="matrix(1 0 0 1 157.1455 32.1655)"
                        className="st3 st4 st5"
                    >
                        409
                    </text>
                    <text
                        id="center-left"
                        transform="matrix(1 0 0 1 85 34.7173)"
                        className="st3 st4 st5"
                    >
                        404
                    </text>
                    <text
                        id="left-center_1_"
                        transform="matrix(1 0 0 1 53.7124 58.1631)"
                        className="st3 st4 st5"
                    >
                        362
                    </text>
                    <text
                        id="left"
                        transform="matrix(1 0 0 1 8.9321 116.0493)"
                        className="st3 st4 st5"
                    >
                        315
                    </text>
                </g>
                <g id="field">
                    <path
                        id="Outfield_1_"
                        className="st6"
                        d="M125.7,222.2c-11.4,0-19.8-9.7-19.8-9.7l-45.4-55.1l1-12.9l-31.3-31.3l2.3-2.7L34,109 l1.6-1.6l1.6-1.6l1.6-1.6l1.6-1.6L42,101l1.6-1.6l1.7-1.6l1.7-1.6l1.7-1.6l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.8-1.7l1.9-1.5 l1.9-1.5l1.9-1.5l1.9-1.5l1.9-1.5l1.9-1.6L67,66.5l1.9-2.2l2-2.2l2-2.2l21.4-15.2l2.5-2l2.6-2.1l2.6-2.1l2.7-2.1l2.7-2.2l2.9-1.4 h45.1l2.6,2.5l2.4,3.1l2.6,1.8l2.3,2.8l2.2,2.8l2.2,2.7l2.1,2.6l2.1,2.6l2,2.5l2,2.5l2.5,0.9l2.7,0.4l1.9,2.4l1.9,2.3l1.8,2.3 l1.8,2.3l1.8,2.2l1.8,2.2l1.7,2.2l1.7,2.1l1.7,2.1l1.7,2.1l1.6,2l1.6,2l1.6,2l1.6,2l1.6,2l1.6,1.9l1.6,1.9l1.5,1.9l1.5,1.9 l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.9l1.5,1.6l-23.5,23.2c0,0,1.8,12.2-6.7,20.6c-5.3,5.2-47.7,59.9-47.7,59.9 S137.1,222.2,125.7,222.2L125.7,222.2z"
                    />
                    <path
                        id="grass_1_"
                        className="st3"
                        d="M125.7,214.2c-7.2,0-13.3-6.3-13.7-6.9l-45.6-54.4l1-10.4l-22.1-22.6v-10.7l16-15.7l1.5-1.4 L78.9,79l-1.8-12.1L112,40.7l39.8,0.1l21,24.6l5.3,2l0.5,0.1l30.4,37.8l-0.7,6.3l-13.5,12.9c0,0,2.1,9-5.1,19 c-4.4,6.2-44.4,54.9-51.5,64.1C138.2,207.7,132.9,214.2,125.7,214.2L125.7,214.2z"
                    />
                    <path
                        id="infield_sand"
                        className="st6"
                        d="M131.9,202.4c0-1.1-0.3-2.1-0.7-3l32.7-32.7l-1-1c-5-16-20-27.7-37.7-27.7 s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7c-0.5,0.9-0.7,1.9-0.7,3c0,0.2,0,0.3,0,0.4l-11.1,2.5l4.4,6.2l7.7-5.7 c1.2,1.9,3.3,3.2,5.7,3.2s4.5-1.3,5.7-3.2l7.7,5.7l4.4-6.2l-11.1-2.5C131.9,202.7,131.9,202.6,131.9,202.4z M120.9,197.3 l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6 l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6C123.6,195.7,122,196.3,120.9,197.3z"
                    />
                </g>
                <g id="persistent_1_">
                    <g id="mound_1_">
                        <path
                            id="pitching-mound_1_"
                            className="st6"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
                        />
                        <path
                            id="pitching-rubber_1_"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4V176.6z"
                        />
                    </g>
                    <g id="lines_1_">
                        <path
                            id="left-foul-line_2_"
                            className="st8"
                            d="M125.2,203.2l-92.7-92.7"
                        />
                        <path
                            id="right-foul-line_2_"
                            className="st8"
                            d="M125.2,203.2l95.7-95.8"
                        />
                    </g>
                    <g id="bases_2_">
                        <rect
                            id="third-base_2_"
                            x={99.2}
                            y={175.1}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -95.3756 122.8773)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="first-base_2_"
                            x={148.1}
                            y={175.2}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -81.1257 157.48)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="second-base_2_"
                            x={123.7}
                            y={148.6}
                            transform="matrix(0.707 -0.7073 0.7073 0.707 -69.4716 132.5411)"
                            className="st10"
                            width={3}
                            height={3}
                        />
                        <polygon
                            id="home_2_"
                            className="st7"
                            points="126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
                        />
                    </g>
                </g>
                <g id="grid" className="st11">
                    <g className="st12">
                        <g id="numbers">
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 90.9866 184.0761)"
                                className="st4 st13"
                            >
                                90
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 56.4654 153.8222)"
                                className="st4 st13"
                            >
                                200
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 71.0452 168.4018)"
                                className="st4 st13"
                            >
                                150
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 80.378 177.7343)"
                                className="st4 st13"
                            >
                                120
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 41.6028 138.9599)"
                                className="st4 st13"
                            >
                                250
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 27.4712 123.956)"
                                className="st4 st13"
                            >
                                300
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 12.6905 109.1753)"
                                className="st4 st13"
                            >
                                350
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 75.9258)"
                                className="st4 st13"
                            >
                                400
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 49.4311)"
                                className="st4 st13"
                            >
                                450
                            </text>
                            <text
                                transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 24.6201)"
                                className="st4 st13"
                            >
                                500
                            </text>
                        </g>
                        <g id="surface29_2_">
                            <path className="st14" d="M125.5,203.8l-148-148" />
                            <path className="st14" d="M124.8,203.8l148-148" />
                            <path className="st15" d="M125.1,203.5L45.4,10.9" />
                            <path className="st15" d="M125.1,203.5V-4.9" />
                            <path
                                className="st15"
                                d="M125.1,203.5l79.8-192.6"
                            />
                        </g>
                        <path
                            id="_x31_00-line"
                            className="st14"
                            d="M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
                        />
                        <path
                            id="_x32_00-line_2_"
                            className="st14"
                            d="M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5c23,0,43.8,9.3,58.8,24.4"
                        />
                        <path
                            id="_x39_0-line_2_"
                            className="st14"
                            d="M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1c10.4,0,19.7,4.2,26.5,11"
                        />
                        <path
                            id="_x31_20-line"
                            className="st14"
                            d="M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4c17.2,0,32.8,7,44.1,18.3"
                        />
                        <path
                            id="_x32_50-line"
                            className="st14"
                            d="M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6c28.7,0,54.7,11.6,73.6,30.5"
                        />
                        <path
                            id="_x33_00-line"
                            className="st14"
                            d="M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
                        />
                        <path
                            id="_x33_50-line"
                            className="st14"
                            d="M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1c40.2,0,76.6,16.3,103,42.7"
                        />
                        <path
                            id="_x34_50-line"
                            className="st14"
                            d="M-7.4,70.9c33.9-34,80.8-55,132.6-55c51.7,0,98.6,21,132.5,54.9"
                        />
                        <path
                            id="_x34_00-line_1_"
                            className="st14"
                            d="M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9c46,0,87.6,18.6,117.7,48.8"
                        />
                        <path
                            id="_x35_00-line"
                            className="st14"
                            d="M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9c57.5,0,109.5,23.3,147.2,61"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default Venue2392
